import type { VueRoute } from "ui-kit/RouterVue";
import { h } from "vue";

const route: VueRoute = {
  path: "/users/:slug?",
  action: async ({ pathname }) => {
    const id = pathname.groups.slug;
    const c = id
      ? await import("./views/userEdit.vue")
      : await import("./views/userList.vue");
    return h(c.default, { id });
  },
};

export default route;
